import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import BreakDurationAPI from '../../../src/api/breakDuration/api-break-duration';
import instance from '@/api/api';

export const fetchBreakDurations = createAsyncThunk(
  'breakDuration/fetchBreakDurations',
  async (_, thunkAPI) => {
    try {
      const response = await BreakDurationAPI.getAll();
      const fetchBreak = await instance.get('api/break-definition/get-all', {
      // const aa = await instance.get('/api/meta-data/get-all?companyId=402AA1DA-B7CB-40E4-9A24-BAB749B369A4 ', {
        conditions: [
          {
            column: 'Reference',
            operator: 1,
            value: 'APP20251015000001',
            value2: '',
            values: [],
          },
        ],
        sortColumn: '',
        sortDirection: '',
        skip: 0,
        take: 100,
        companyID: '',



      });
      // console.log('fetchBreak>>>>', fetchBreak);
      // console.log('response>>>>', response);

      return response?.data?.data ?? [];
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);


// export const fetchBreakDurations = createAsyncThunk(
//   'breakDuration/fetchBreakDurations',
//   async (_, thunkAPI) => {
//     try {
//       //  1. Existing API call
//       const response = await BreakDurationAPI.getAll();

//       // 2. New MetaData API call
//       const metaResponse = await instance.get(
//         '/api/meta-data/get-all',
//         {
//           params: {
//             companyId: '402AA1DA-B7CB-40E4-9A24-BAB749B369A4',
//           },
//         }
//       );

//       console.log('MetaData Response:', metaResponse.data);
//       console.log('Break Definition Response:', response.data);

//       // You can decide what to return (merge, or separate)
//       return {
//         breakDurations: response?.data?.data ?? [],
//         metaData: metaResponse?.data ?? {},
//       };
//     } catch (error) {
//       console.error('API error:', error);
//       return thunkAPI.rejectWithValue(error.message);
//     }
//   }
// );


export const addBreakDuration = createAsyncThunk(
  'breakDuration/addBreakDuration',
  async (payload, thunkAPI) => {
    try {
      const response = await BreakDurationAPI.add(payload);
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const updateBreakDuration = createAsyncThunk(
  'breakDuration/updateBreakDuration',
  async (payload, thunkAPI) => {
    try {
      const response = await BreakDurationAPI.update(payload.id, payload);
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const deleteBreakDuration = createAsyncThunk(
  'breakDuration/deleteBreakDuration',
  async (ids, thunkAPI) => {
    try {
      await BreakDurationAPI.delete(ids); // pass single or multiple IDs
      return ids; // return single ID or array of IDs
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Initial State
const initialState = {
  list: [],
  loading: false,
  error: '',
};

// Slice
const breakDurationSlice = createSlice({
  name: 'breakDuration',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBreakDurations.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(fetchBreakDurations.fulfilled, (state, action) => {
        state.loading = false;
        // state.list = action.payload;
        state.list = [...action.payload];
      })
      .addCase(fetchBreakDurations.rejected, (state, action) => {
        state.loading = false;
        state.list = [];
        state.error = action.payload ?? 'An error occurred';
      })
      .addCase(addBreakDuration.fulfilled, (state, action) => {
        // state.list.push(action.payload);
        state.list.unshift(action.payload);
      })
      .addCase(updateBreakDuration.fulfilled, (state, action) => {
        const index = state.list.findIndex(
          (item) => item.id === action.payload.id
        );
        if (index !== -1) {
          state.list[index] = action.payload;
        }
      })

      .addCase(deleteBreakDuration.fulfilled, (state, action) => {
        const idsToDelete = Array.isArray(action.payload)
          ? action.payload
          : [action.payload];

        // console.log('Removing IDs:', idsToDelete);

        state.list = state.list.filter(
          (item) => !idsToDelete.includes(item.id)
        );
      });
  },
});

export default breakDurationSlice.reducer;
